export default "__VITE_ASSET__lzzTtMW9__"